export default "__VITE_ASSET__B86b9kv0__"